<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--返回上一页-->
    <div class="backBg">
      <a href="javascript:history.go(-1)">
        <div class="backBox">
          <span class="backIcon"></span>
        </div>
      </a>
      <div class="topTitle">
        <span>制单详情</span>
      </div>
    </div>
    <div class="content_bg">
      <div class="o_blue_box">
        <!--搜索框-->
        <div class="searchBg">
          <div class="weui-search-bar" id="searchBar" ref="searchBar">
            <form class="weui-search-bar__form">
              <div class="weui-search-bar__box">
                <i class="weui-icon-search"></i>
                <input type="search" class="weui-search-bar__input" id="searchInput" ref="sel_date" placeholder="请选择日期~" required readonly @input="checkSearch" @click="selDate"/>
                <a href="javascript:" class="weui-icon-clear" id="searchClear" ref="searchClear" @click="clearSearch"></a>
              </div>
              <label class="weui-search-bar__label" id="searchText" ref="searchText" @click="clickSearch">
                <i class="weui-icon-search"></i>
                <span>日期查询~</span>
              </label>
            </form>
            <a href="javascript:" class="weui-search-bar__cancel-btn" id="searchSubmit" ref="searchSubmit" @click="search">取消</a>
          </div>
        </div>

        <!--列表-->
        <div class="check_list_bg">
          <div class="check_list_box" v-for="item,index in list">
            <div class="check_list_w">
              <div class="d_f_box">
                <div class="d_f_1">
                  <p>针车中仓</p>
                </div>
                <p class="order_date">2019-10-08</p>
              </div>
              <div class="d_f_box">
                <div class="d_f_1">
                  <p class="color_999999">针车中仓入库总数</p>
                </div>
                <p class="color_4598FF">7812件</p>
              </div>
              <div class="d_f_box">
                <div class="d_f_1">
                  <p class="color_999999">针车中仓出库总数</p>
                </div>
                <p class="color_4598FF">7812件</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'orderCheck',
    data(){
      return{
        list:['get_more1','get_more2']
      }
    },
    created:function () {
      var that = this;
      //    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      点击搜索框
      clickSearch(){
        this.$refs.searchBar.classList.add('weui-search-bar_focusing');
        this.selDate();
      },
//      选择日期
      selDate(){
        var sel_date = this.$refs.sel_date;
        var searchSubmit = this.$refs.searchSubmit;
        var searchClear = this.$refs.searchClear;
        weui.datePicker({
          start: 1990,
          end: new Date().getFullYear(),
          onChange:function (result) {

          },
          onConfirm: function (result) {
            sel_date.value = result[0] + '-' + result[1] + '-' + result[2];
            searchSubmit.innerHTML = '搜索';
            searchClear.style.display = 'block';
          },
        })
      },
//      取消搜索
      cancelSearch(){
        this.$refs.searchBar.classList.remove('weui-search-bar_focusing');
        this.$refs.sel_date.blur();
      },
//      清除搜索内容
      clearSearch(){
//        this.$refs.sel_date.focus();
        this.$refs.sel_date.value = '';
        this.$refs.searchClear.style.display = 'none';
        this.$refs.searchSubmit.innerHTML = '取消';
      },
//      搜索框失去焦点
      blurSearch(){
        if(!this.$refs.sel_date.value.length){
          this.cancelSearch();
          this.$refs.searchSubmit.innerHTML = '取消';
        }
      },
//      监听搜索
      checkSearch(){
        if(this.$refs.sel_date.value.length){
          this.$refs.searchSubmit.innerHTML = '搜索';
        }
      },
//      点击搜索
      search(){
        if(this.$refs.sel_date.value.length){
          console.log(this.$refs.sel_date.value);
        }else{
          this.cancelSearch();
        }
      },
//      展开列表
      getMore(index){
        var get_more = this.$refs.get_more[index];
        if(get_more.classList[1] == 'get_more_arr'){
          get_more.classList.remove('get_more_arr');
          get_more.classList.add('get_more_arr2');
          get_more.innerHTML = '收起';
        }else{
          get_more.classList.remove('get_more_arr2');
          get_more.classList.add('get_more_arr');
          get_more.innerHTML = '查看更多';
        }
      }
    },
    beforeRouteEnter(to,from,next){
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.document.body.style.background = '';
      next();
    }
  }
</script>

<style scoped>
  .d_f_box{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderDetail.vue